<template>
  <div class="plan-group">
    <div class="plan-group__title">
      {{ $t("message.payments.paymentMethod") }}
    </div>
    <div class="plan-list">
      <div
        v-for="item in availablePaymentMethods"
        :key="item.id"
        class="plan-list__item"
        :class="{ 'is-active': item.value === selectedPaymentMethod.value }"
        @click="selectItem(item)"
      >
        <div class="plan-list__content">
          <div class="plan-list__title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cuid from "cuid";
const CARD_ONLY_CURRENCIES = ["gbp", "usd"];
export default {
  name: "PaymentMethodSelector",
  data() {
    return {
      plan: null,
      planItems: [
        {
          id: cuid(),
          value: "card",
          title: this.$t("message.payments.payByCard")
        },
        {
          id: cuid(),
          value: "p24",
          title: this.$t("message.payments.payByQuickPayment")
        }
      ]
    };
  },
  computed: {
    selectedPaymentMethod() {
      return this.$store.state.payments.selectedPaymentMethod;
    },
    currency() {
      return this.$store.state.payments.currency;
    },
    availablePaymentMethods() {
      return CARD_ONLY_CURRENCIES.includes(this.currency.toLowerCase())
        ? this.planItems.filter(item => item.value === "card")
        : this.planItems;
    }
  },
  created() {
    if (!this.selectedPaymentMethod) {
      this.$store.dispatch(
        "payments/setSelectedPaymentMethod",
        this.planItems[0]
      );
    }
  },
  methods: {
    selectItem(item) {
      this.plan = item.title;
      this.$store.dispatch("payments/setSelectedPaymentMethod", item);
    }
  }
};
</script>

<style lang="scss" scoped>
.plan-group {
  display: flex;
  flex-direction: column;
  gap: $spacing;

  &__title {
    line-height: 1em;
    @include font-size(14px);
  }
}
.plan-list {
  display: flex;
  gap: $spacing * 2;

  &__item {
    cursor: pointer;
    display: flex;
    background: white;
    border: 1px solid $gray-300;
    padding: 0 $spacing * 3;
    height: 46px;
    border-radius: 8px;
    align-items: center;
    transition-property: border-color, background;
    transition-duration: 0.2s;

    &:hover,
    &.is-active {
      border-color: $primary;
      background: $gray-500;
    }

    &.is-active {
      position: relative;
      .plan-list__title {
        color: $primary;
      }

      &:after {
        font: normal normal bold 13px/1.25 "Material Design Icons";
        position: absolute;
        text-align: center;
        right: -8px;
        top: -8px;
        border-radius: 100%;
        content: "\F12C";
        color: white;
        width: 16px;
        height: 16px;
        background: $primary;
        animation: showCheckbox 0.3s;
      }
    }
  }

  &__title {
    @include font-size(14px);
    font-weight: 600;
    line-height: 1em;
  }

  &__content {
    gap: $spacing * 0.5;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &__action {
    cursor: pointer;
  }
}

@keyframes showCheckbox {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
